module.exports = __webpack_public_path__ + "insa-report/web/locale/de/viewer.properties";


//////////////////
// WEBPACK FOOTER
// ./app/insa-report/web/locale/de/viewer.properties
// module id = 973
// module chunks = 3